import type { GemmetricLiteScanResult } from '../types/organizations';

const isLocalDev = (): boolean => {
  return typeof window !== 'undefined' && window.location.hostname === 'localhost';
};

export const runGemmetricLiteScan = async (website: string): Promise<GemmetricLiteScanResult> => {
  const endpoint = isLocalDev()
    ? 'http://localhost:8888/.netlify/functions/gemmetric-lite-scan'
    : '/.netlify/functions/gemmetric-lite-scan';

  const resp = await fetch(endpoint, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ website })
  });

  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data?.error || `Lite scan failed (HTTP ${resp.status})`);
  }

  return data as GemmetricLiteScanResult;
};
